import {
  CollectionIcon,
  css,
  FormField,
  Inline,
  ListItem,
  NumericStepper,
  SelectInput,
  styled,
} from 'canoe';
import React from 'react';

import Section from 'craft/containers/Toolbox/components/Section';
import ValueBox from 'craft/containers/Toolbox/components/ValueBox';
import ValueGroup from 'craft/containers/Toolbox/components/ValueGroup';

import { CollectionItem, CollectionSelectorImplProps } from './types';

const StepperWrapper = styled.div`
  ${({ theme }) => css`
    height: 100%;
    border-left: 1px solid ${theme.colors.GlitterGray};
  `}
`;
const StyledValueBox = styled(ValueBox)`
  ${({ theme }) => css`
    overflow: hidden;
    color: ${theme.colors.OnyxGrayD10};
    border: 1px solid ${theme.colors.GlitterGray};
    border-radius: ${theme.borderRadius.small};
    background-color: ${theme.colors.GlitterGrayL20};
  `}
`;

export const TextButton = styled.button`
  ${({ theme }) => css`
    background-color: transparent;
    border: none;
    font-size: ${theme.fonts.small.fontSize};
    margin-top: ${theme.spaces.xxs}
    text-decoration: underline;
    cursor: pointer;
  `}
`;

export const CollectionSelectorToolbox: React.FC<CollectionSelectorImplProps> = React.memo(
  ({
    collectionId,
    onChangeSource,
    items,
    maxRecords,
    onChangeMaxRecords,
    onRedirectToCollection,
  }: CollectionSelectorImplProps) => {
    return (
      <Section name="Collection">
        <FormField data-cy="field-selection" scale="small" label="Get Records from Collection">
          <SelectInput<CollectionItem>
            renderValue={({ selectedItem, ...selectedItemProps }) => (
              <ListItem
                prefix={<CollectionIcon size="s" color="OnyxGrayL10" />}
                {...selectedItemProps}
              >
                {selectedItem?.label}
              </ListItem>
            )}
            selectedItem={items.find(({ value }: { value: string }) => collectionId === value)}
            items={items}
            onSelect={(selected) => onChangeSource(selected)}
          />
        </FormField>
        {collectionId && (
          <>
            <ValueGroup>
              <StyledValueBox label="Records displayed">
                <StepperWrapper>
                  <NumericStepper
                    value={maxRecords}
                    name="records"
                    scale="small"
                    valueSuffix="/20 max"
                    editable
                    format="inline"
                    maxValue={20}
                    minValue={1}
                    step={1}
                    onChange={onChangeMaxRecords}
                  />
                </StepperWrapper>
              </StyledValueBox>
            </ValueGroup>
            <Inline justify="flex-end">
              <TextButton onClick={onRedirectToCollection}>Open Collection</TextButton>
            </Inline>
          </>
        )}
      </Section>
    );
  },
);
